import { render, staticRenderFns } from "./productSorting.vue?vue&type=template&id=31f13322&scoped=true"
import script from "./productSorting.vue?vue&type=script&lang=js"
export * from "./productSorting.vue?vue&type=script&lang=js"
import style0 from "./productSorting.vue?vue&type=style&index=0&id=31f13322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f13322",
  null
  
)

export default component.exports